<template>
    <div class="pushup">
        <div v-for="(pushup,key) in pushUpsList" :key="key" class="goods_pushup">
            <div class="pushup_img">
                <!-- <img :src="require('assets/img/mwap/point.png')"  alt=""> -->
            </div>           
            <div class="pushup_item" @click="go(pushup)">
                <div class="pushup_title">
                    <div class="it">{{pushup.title}}</div>
                    <div class="cont"><img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20220326/1648297476/428663.png"  alt="">时间：{{pushup.start_time_show}} ～ {{pushup.end_time_show}}</div>
                </div>
                <img :src="require('assets/img/common/wmap_right.png')"  alt="">
            </div>            
        </div>
    </div>
</template>
<script>
    import './index.less'
    export default {
        name:"PushUpsList",
        props:{
            pushUpsList:Array
        },
        methods: {
            go:function (val) {
                console.log(val)
                this.$emit('goDetail',val);
            }
        }
    }
</script>